import React from 'react';
import { Box, Typography, Link } from "@mui/material";

import images from "../../resources/export";
import { CONTATTI, FAQ, PRIVACY, } from '../../global/urlMapping';


export const Footer = () => {

    return (
        <Box component="footer" sx={{ width: '100%', display: { xs: 'flex', md: 'flex' }, flexDirection: { xs: 'column', md: 'row' }, backgroundColor: '#005397', position: 'relative', bottom: '0 !important', }}>
            <Box sx={{ width: { xs: '100%', md: '33.33%' }, height: '150px', display: { xs: 'none', md: 'flex' }, margin: '0 auto' }}>
                <img src={images.loghi.alisa} alt='Logo Alisa' style={{ height: '80px', margin: 'auto' }} />
            </Box>
            <Box sx={{ width: { xs: '100%', md: '33.33%' }, height: { xs: '100px', md: '250px' }, backgroundColor: 'transparent', display: { xs: 'flex', md: 'none' }, margin: '0 auto' }}>
                <img src={images.loghi.alisa} alt='Logo Alisa' style={{ width: '150px', margin: 'auto' }} />
            </Box>
            <Box sx={{ width: { xs: '100%', md: '33.33%' }, height: { md: '150px' }, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', margin: '0 auto' }}>
                <Box sx={{ backgroundColor: 'transparent', justifyContent: 'flex-start', color: 'white', fontSize: { xs: '15px', md: '20px' }, display: 'flex', flexDirection: 'column', margin: 'auto', alignItems: "center" }}>
                    <Typography sx={{ color: 'white', fontSize: { xs: '15px', md: '20px' }, textAlign: { xs: 'center', md: 'left' }, margin: 'auto 0' }}>
                        <Link href={CONTATTI} className='linkFooter' sx={{ color: 'white', fontSize: { xs: '14px', md: '18px' }, textAlign: 'center', margin: 'auto' }}> Contatti e Informazioni </Link>
                        -
                        <Link href={FAQ} className='linkFooter' sx={{ color: 'white', fontSize: { xs: '14px', md: '18px' }, margin: 'auto' }}> FAQ </Link>
                        -
                        <Link href={PRIVACY} className='linkFooter' sx={{ color: 'white', fontSize: { xs: '14px', md: '18px' }, textAlign: 'center', margin: 'auto' }}> Privacy policy </Link>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ width: { xs: '100%', md: '33.33%' }, height: '100px', margin: '0 auto', display: { xs: 'none', md: 'flex' } }}>
                <img src={images.loghi.logoLDBianco} alt='Logo Liguria Digitale' style={{ height: '90px', margin: '30px auto' }} />
            </Box>
            <Box sx={{ width: { xs: '100%', md: '33.33%' }, height: '100px', backgroundColor: 'transparent', margin: '0 auto', display: { xs: 'flex', md: 'none' } }}>
                <img src={images.loghi.logoLDBianco} alt='Logo Liguria Digitale' style={{ height: '50px', margin: 'auto' }} />
            </Box>
        </Box>
    );
}